module.exports = __webpack_public_path__ + "static/media/Marketing-Page-updated.8cbe2b24.png";